// extracted by mini-css-extract-plugin
export var cartContainer = "_me-4";
export var gray = "_me-1";
export var itemContainer = "_me-2";
export var itemDetails = "_me-3";
export var strong = "_me-0";